import React, { useState } from 'react';
import api from '../api/api';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, Store } from 'lucide-react';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
const response = await api.post('/api/stores/login', {
      email,
        password,
      });

      if (response.data.success) {
        localStorage.setItem('user', JSON.stringify(response.data));
        const designation = response.data.designation?.trim();

        if (designation === 'Admin' || designation === 'Super Admin') {
          navigate('/stores_detail');
        } else if (designation === 'RSM' || designation === 'Regional Manager') {
          navigate('/reports');
        } else {
          navigate('/');
        }
      } else {
        setError(response.data.message || 'Invalid credentials');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Server error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background: 'linear-gradient(145deg, #121212 0%, #1c1c1c 50%, #0a0a0a 100%)',
      }}
    >
      {/* Top gold line - same as sidebar */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: '2px',
        background: 'linear-gradient(90deg, transparent, #FFD166, #F6B040, #FFD166, transparent)',
        zIndex: 100,
      }} />

      <div
        className="p-8 rounded-2xl shadow-2xl w-full max-w-md"
        style={{
          background: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255, 209, 102, 0.3)',
          boxShadow: '0 25px 50px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,209,102,0.1)',
          backdropFilter: 'blur(12px)',
        }}
      >
        <div className="flex justify-center mb-6">
          <div style={{ background: '#FFD166' }} className="p-3 rounded-full shadow-lg">
            <Store className="text-black" size={32} />
          </div>
        </div>

        <h2 className="text-3xl font-bold text-center mb-2" style={{ color: '#FFD166' }}>
         Sign In
        </h2>
        <p className="text-center text-sm mb-6" style={{ color: 'rgba(255,255,255,0.5)' }}>
Sign in to access your dashboard        </p>

        {error && (
          <div className="p-3 rounded-lg mb-4 text-sm"
            style={{ background: 'rgba(239,68,68,0.2)', color: '#fca5a5', border: '1px solid rgba(239,68,68,0.3)' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="relative mb-4">
            <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2" size={18}
              style={{ color: 'rgba(255,255,255,0.4)' }} />
            <input
              type="email"
              placeholder="Email"
              className="w-full pl-10 pr-4 py-3 rounded-lg outline-none text-white"
              style={{
                background: 'rgba(0,0,0,0.4)',
                border: '1px solid rgba(255,255,255,0.15)',
                transition: 'border-color 0.2s',
              }}
              onFocus={e => e.target.style.borderColor = '#FFD166'}
              onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="relative mb-6">
            <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2" size={18}
              style={{ color: 'rgba(255,255,255,0.4)' }} />
            <input
              type="password"
              placeholder="Password"
              className="w-full pl-10 pr-4 py-3 rounded-lg outline-none text-white"
              style={{
                background: 'rgba(0,0,0,0.4)',
                border: '1px solid rgba(255,255,255,0.15)',
                transition: 'border-color 0.2s',
              }}
              onFocus={e => e.target.style.borderColor = '#FFD166'}
              onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 font-bold rounded-lg transition-all duration-200"
            style={{
              background: loading ? '#555' : '#FFD166',
              color: '#000',
              opacity: loading ? 0.7 : 1,
              boxShadow: loading ? 'none' : '0 4px 15px rgba(255,209,102,0.4)',
            }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
    
  );
};

export default LoginPage;